<template>
  <div 
    :class="{'colorized': isColorized, 'has-image': hasImage }" 
    class="ec-answer ec-click"
    @click="clickClick">
    <span 
      v-show="effectedWarningEnabled"
      aria-label="Durch das Verändern dieser Frage werden alle Folgefragen zurückgesetzt."
      class="ec-answer-effected-warning-edge hint--bottom-left hint--medium">
      <i 
        class="fa fa-exclamation" 
        aria-hidden="true" />
    </span>
    <div class="ec-answer-main">
      <div 
        class="ec-answer-text" 
        v-html="answer.answer"/>
    </div>
    <div 
      v-if="hasImage" 
      class="ec-answer-image" 
      @click="showImage">
      <div class="ec-answer-img-wrapper">
        <div class="ec-answer-img-overlay">
          <div class="ec-img-overlay-icon"><i 
            aria-hidden="true" 
            class="fa fa-search"/></div>
        </div> 
        <img :src="imageSrc" >
      </div>
    </div>
    <AnswerDebug 
      v-if="answer.additional_informations" 
      :debug-info="answer.additional_informations"
    />
  </div>
</template>
<script>
    import Answer from './Answer.vue'

    export default {
        name: "ClickAnswer",
        components: {},
        extends: Answer,
        methods: {
            clickClick(event) {
              if(this.isSelected) {
                  this.$event.$emit('next')
                  return
              }

              if(this.$store.readOnly) {
                return
              }

              if(this.effectedWarningEnabled) {
                this.goingToChangeValue()
                event.preventDefault(event)
                return
              }

              this.selectAnswer(null, this.answer.id)
            },
        },
    }
</script>